import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//?  English Version
import inviteMembersInstruction1 from "../../../assets/img/tutorialimages/addMemberGuide1.png";
import inviteMembersInstruction2 from "../../../assets/img/tutorialimages/addMemberGuide2.png";
import inviteMembersInstruction3 from "../../../assets/img/tutorialimages/addMemberGuide3.png";
import inviteMembersInstruction4 from "../../../assets/img/tutorialimages/addMemberGuide4.png";
//? Japanese Version
import inviteMembersInstruction1Jap from "../../../assets/img/tutorialimages/addMemberGuide1_Jap.png";
import inviteMembersInstruction2Jap from "../../../assets/img/tutorialimages/addMemberGuide2_Jap.png";
import inviteMembersInstruction3Jap from "../../../assets/img/tutorialimages/addMemberGuide3_Jap.png";
import inviteMembersInstruction4Jap from "../../../assets/img/tutorialimages/addMemberGuide4_Jap.png";
import inviteMembersInstruction5Jap from "../../../assets/img/tutorialimages/addMemberGuide5_Jap.png";

class InviteMemberGuide extends Component {
  state = {
    language: "en",
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    if (this.state.language === "en") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={inviteMembersInstruction1}
            alt="inviteMembersInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              heightt: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction2}
            alt="inviteMembersInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction3}
            alt="inviteMembersInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction4}
            alt="inviteMembersInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.language === "ja") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={inviteMembersInstruction1Jap}
            alt="inviteMembersInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction2Jap}
            alt="inviteMembersInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction3Jap}
            alt="inviteMembersInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction4Jap}
            alt="inviteMembersInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction5Jap}
            alt="inviteMembersInstruction5"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.language === "es") {
      return (
        <div
          style={{
            width: "90%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={inviteMembersInstruction1}
            alt="inviteMembersInstruction1"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction2}
            alt="inviteMembersInstruction2"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction3}
            alt="inviteMembersInstruction3"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
          <img
            className="imgStyle"
            src={inviteMembersInstruction4}
            alt="inviteMembersInstruction4"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
}

export default InviteMemberGuide;
